import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './index.module.scss';

const ExpiredLink: React.FC = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <div className={styles.expiredLinkContainer}>
      <div className={styles.expiredLinkBox}>
        <h2 className={styles.expiredLinkTitle}>
          This link has expired or is no longer valid
        </h2>
        <p className={styles.expiredLinkDescription}>
          If you need help, please contact our help desk.
        </p>
        <button onClick={handleGoHome} className={styles.expiredLinkButton}>
          Go to home page
        </button>
      </div>
    </div>
  );
};

export default ExpiredLink;
